/* eslint-disable react/prop-types */
import React, { useState, useEffect } from 'react';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import { compose } from 'recompose';
import { Switch } from 'react-router-dom';
import { connect } from 'react-redux';
import * as Yup from 'yup';
import { withFormik } from 'formik';
import { pathToRegexp } from 'path-to-regexp/dist';
import { logout, manageUserTerms, auth, changePasswordFirstAccess } from 'login/loginActions';
import { getEssaySsoUrl } from 'reports/application-detail/reportApplicationDetailsActions';
import { getLogsRead } from 'control-panel/controlPanelActions';
import { useLogsReadOnNavigate } from 'control-panel/useLogsReadOnNavigate';

import { Modal, Loader } from 'sa-ui';

import { injectIntl, intlShape, FormattedMessage } from 'react-intl';

import AppRoute from './AppRoute';
import AppSidebar from './AppSidebar';
import AppNavbar from './AppNavbar';
import AppLogoutModal from './AppLogoutModal';
import ModalOptIn from './ModalOptIn';

import messagesChange from '../changePassword/changePasswordMessages';
import messages from './appMessages';

import AppFooter from './AppFooter';

function getActiveRoute(routes) {
  return routes.find((route) => pathToRegexp(route.path).test(window.location.pathname));
}

function isExpanded(routes) {
  const activeRoute = getActiveRoute(routes);
  let expanded = true;
  if (activeRoute) {
    expanded = !activeRoute.expanded;
  }

  return expanded;
}

const shapeChangePasswordShapeSchema = {
  idUser: Yup.string(),
  email: Yup.string(),
  password: Yup.string()
    .required('errorRequired')
    .matches(/^(?=.*[A-Za-z])(?=.*\d)(?=.*[@$!%*#?&])[A-Za-z\d@$!%*#?&]{8,}$/, 'errorStrong'),
  confirmPassword: Yup.string()
    .oneOf([Yup.ref('password'), null], 'errorDontMatch')
    .required('errorRequired'),
};

const ChangePasswordSchema = Yup.object().shape(shapeChangePasswordShapeSchema);

const initialValues = {
  idUser: '',
  email: '',
  password: '',
  confirmPassword: '',
};

const enhanceForm = withFormik({
  mapPropsToValues: () => ({}),
  initialValues,
  validationSchema: ChangePasswordSchema,
  handleSubmit: async (values, { props }) => {
    const payload = { ...values, idAccess: 7 };
    // console.log(payload, props);
    await props.changePasswordFirstAccess(payload);
  },
});

function checkError({ errors, touched, field, type }) {
  if (errors[field] && touched[field]) {
    if (type === 'border') {
      return { border: 'solid 1px red' };
    }
    if (type === 'label') {
      return { color: 'red' };
    }
  }
  return {};
}

const AppContainer = ({ routes, app, ...props }) => {
  const [showLogout, setShowLogout] = useState(false);
  const [showChangePass, setShowChangePass] = useState(false);
  const [viewPassword, setViewPassword] = useState(false);
  const [viewPasswordConfirm, setViewPasswordConfirm] = useState(false);
  const expanded = isExpanded(routes);
  const [required, setRequired] = useState({
    minimum: false,
    uppercase: false,
    lowercase: false,
    numbers: false,
    specialCaracter: false,
  });
  const {
    intl,
    errors,
    touched,
    handleSubmit,
    handleChange,
    handleBlur,
    changePasswordFirstAccessStatus,
    manageUserTermsPass,
    user,
    location,
    isValid,
    setFieldValue,
    isLoading,
    values,
  } = props;

  const isDisabled = !isValid;
  const { firstName } = user;

  useLogsReadOnNavigate(location, user, props.getLogsRead);

  const toggleLogout = (show) => () => {
    setShowLogout(show);
  };

  useEffect(() => {
    callAuth();
  }, [manageUserTermsPass]);

  async function callAuth() {
    if (manageUserTermsPass) {
      await props.auth();
    }

    if (location.pathname.indexOf('/simulated/') === -1) {
      localStorage.removeItem('idCSchool');
      localStorage.removeItem('idESCourse');
    }
  }

  useEffect(() => {
    if (user.firstAccess === null) {
      setShowChangePass(true);
      setFieldValue('email', user.email);
      setFieldValue('idUser', user.idUser);
    }
  }, []);

  useEffect(() => {
    props.getEssaySsoUrl();
  }, []);

  useEffect(() => {
    if (changePasswordFirstAccessStatus === 200) {
      setTimeout(() => {
        window.location.reload(false);
      }, 1500);
    }
  }, [changePasswordFirstAccessStatus]);

  useEffect(() => {
    if (values.password) {
      setRequired({
        minimum: values.password.length >= 8,
        uppercase: !!values.password.match(/[A-Z]/g),
        lowercase: !!values.password.match(/[a-z]/g),
        numbers: !!values.password.match(/\d+/g),
        specialCaracter: !!values.password.match(/[!@#$%&*?]/g),
      });
    }
  }, [values]);

  function handleViewPassword() {
    setViewPassword(!viewPassword);
  }

  function handleViewPasswordConfirm() {
    setViewPasswordConfirm(!viewPasswordConfirm);
  }

  return (
    <div>
      {user.idType === 4 && user.firstAccess === null && (
        <div>
          <Loader show={isLoading} />
          <Modal
            show={showChangePass}
            icon="ti-lock"
            title={intl.formatMessage(messages.titleNewAccess, { firstName })}
            subtitle={intl.formatMessage(messages.subtitleNewAccess)}
            onClose={props.logout}
            buttons={[
              {
                label: intl.formatMessage(messages.cancel),
                onClick: props.logout,
              },
            ]}
          >
            <form className="col ml-auto mr-auto" onSubmit={handleSubmit}>
              {changePasswordFirstAccessStatus === 200 && (
                <div className="boxMsg alert alert-success">
                  {intl.formatMessage(messages.confirmedChangePassword)}
                </div>
              )}
              {changePasswordFirstAccessStatus && changePasswordFirstAccessStatus !== 200 && (
                <div className="boxMsg alert alert-danger">
                  {intl.formatMessage(messages.genericError)}
                </div>
              )}
              <div className="form-group form-group-mob">
                <input
                  className="form-control"
                  name="idUser"
                  type="hidden"
                  value={user.idUser}
                  disabled
                />
              </div>
              <div className="form-group form-group-mob">
                <input
                  className="form-control"
                  name="email"
                  type="hidden"
                  value={user.email}
                  disabled
                />
              </div>
              <div
                className="form-group form-group-mob"
                style={{ position: 'relative', textAlign: 'left' }}
              >
                <label
                  htmlFor="form-password"
                  style={checkError({ errors, touched, field: 'password', type: 'label' })}
                >
                  {intl.formatMessage(messagesChange.password)}
                </label>
                <input
                  className="form-control input-password"
                  onChange={handleChange}
                  name="password"
                  onBlur={handleBlur}
                  type={viewPassword ? 'text' : 'password'}
                  style={checkError({ errors, touched, field: 'password', type: 'border' })}
                />
                <a className="pass-icon" onClick={() => handleViewPassword()}>
                  <i className="far fa-eye" />
                </a>
                {errors.password === 'errorStrong' && touched.password && <PassStrongField />}
                {errors.password === 'errorRequired' && touched.password && <RequiredField />}
                <div className="card card-password required-pass-card">
                  <FormattedMessage {...messagesChange.passCriterio} />
                  <ul>
                    <li className={`relative ${required.minimum ? 'checked' : ''}`}>
                      {required.minimum ? <i className="ti-check" /> : <i className="ti-close" />}
                      <FormattedMessage {...messagesChange.caracterNumber} />
                    </li>
                    <li className={`relative ${required.uppercase ? 'checked' : ''}`}>
                      {required.uppercase ? <i className="ti-check" /> : <i className="ti-close" />}
                      <FormattedMessage {...messagesChange.letterUppercase} />
                    </li>
                    <li className={`relative ${required.lowercase ? 'checked' : ''}`}>
                      {required.lowercase ? <i className="ti-check" /> : <i className="ti-close" />}
                      <FormattedMessage {...messagesChange.letterLowercase} />
                    </li>
                    <li className={`relative ${required.numbers ? 'checked' : ''}`}>
                      {required.numbers ? <i className="ti-check" /> : <i className="ti-close" />}
                      <FormattedMessage {...messagesChange.number} />
                    </li>
                    <li className={`relative ${required.specialCaracter ? 'checked' : ''}`}>
                      {required.specialCaracter ? (
                        <i className="ti-check" />
                      ) : (
                        <i className="ti-close" />
                      )}
                      <FormattedMessage {...messagesChange.specialCaracter} /> {` ! @ # $ % & * ?)`}
                    </li>
                  </ul>
                </div>
              </div>
              <div
                className="form-group form-group-mob"
                style={{ position: 'relative', textAlign: 'left' }}
              >
                <label
                  htmlFor="form-password"
                  style={checkError({
                    errors,
                    touched,
                    field: 'confirmPassword',
                    type: 'label',
                  })}
                >
                  {intl.formatMessage(messagesChange.confirmPassword)}
                </label>
                <input
                  className="form-control input-password"
                  name="confirmPassword"
                  type={viewPasswordConfirm ? 'text' : 'password'}
                  onChange={handleChange}
                  onBlur={handleBlur}
                  style={checkError({ errors, touched, field: 'confirmPassword', type: 'border' })}
                />
                <a className="pass-icon" onClick={() => handleViewPasswordConfirm()}>
                  <i className="far fa-eye" />
                </a>
                {errors.confirmPassword === 'errorDontMatch' && touched.password && (
                  <ConfirmPassDontMatch />
                )}
                {errors.confirmPassword === 'errorRequired' && touched.confirmPassword && (
                  <RequiredField />
                )}
              </div>
              <FormattedMessage {...messagesChange.button}>
                {(msg) => (
                  <button
                    className="btn btn-primary btn-lg btn-block"
                    type="submit"
                    disabled={isDisabled}
                    style={{ cursor: isDisabled ? 'not-allowed' : 'pointer', marginTop: '30px' }}
                    setFieldValue={('email', 'idUser')}
                  >
                    {msg}
                  </button>
                )}
              </FormattedMessage>
            </form>
          </Modal>
        </div>
      )}

      {user.idType === 4 && user.termsUse === null && user.firstAccess !== null && (
        <ModalOptIn
          user={user}
          userName={user.firstName}
          onClose={props.logout}
          onSubmit={props.manageUserTerms}
        />
      )}
      {user.idType !== 4 && user.termsUse === null && (
        <ModalOptIn
          user={user}
          userName={user.firstName}
          onClose={props.logout}
          onSubmit={props.manageUserTerms}
        />
      )}
      <AppNavbar onRequestLogout={toggleLogout(true)} />
      <AppSidebar routes={routes} collapsed={expanded} />
      <div className={classNames('content-wrapper', { 'content-wrapper--expanded': expanded })}>
        <div className="container">
          <Switch>
            {routes.map((route) => (
              <AppRoute key={route.path} {...route} />
            ))}
          </Switch>
        </div>
      </div>
      <AppLogoutModal show={showLogout} onLogout={props.logout} onClose={toggleLogout(false)} />
      <AppFooter />
    </div>
  );
};

const RequiredField = () => (
  <div style={{ color: 'red', fontSize: '10px' }}>
    <FormattedMessage {...messagesChange.requiredField} />
  </div>
);

const ConfirmPassDontMatch = () => (
  <div style={{ color: 'red', fontSize: '10px' }}>
    <FormattedMessage {...messagesChange.confirmPassDontMatch} />
  </div>
);

const PassStrongField = () => (
  <div style={{ color: 'red', fontSize: '10px' }}>
    <FormattedMessage {...messagesChange.passwordNotStrong} />
  </div>
);

AppContainer.propTypes = {
  routes: PropTypes.arrayOf(PropTypes.shape({ path: PropTypes.string })).isRequired,
  logout: PropTypes.func.isRequired,
  manageUserTerms: PropTypes.func.isRequired,
  auth: PropTypes.func.isRequired,
  intl: intlShape.isRequired,
};

function mapStateToProps({ app, login }) {
  return {
    user: app.user,
    manageUserTermsPass: login.manageUserTermsPass,
    changePasswordFirstAccessStatus: login.changePasswordFirstAccessStatus,
    isLoading: login.isLoading,
  };
}

export default compose(
  injectIntl,
  connect(mapStateToProps, {
    logout,
    manageUserTerms,
    auth,
    changePasswordFirstAccess,
    getEssaySsoUrl,
    getLogsRead,
  }),
  enhanceForm,
)(AppContainer);
